export default "__VITE_ASSET__Bp096SOY__"